import { DistributorPrice } from 'types/api/distributor.type';

import { Image } from 'components/Image';

import { useItem } from './Item.hooks';
import * as S from './Item.styles';

type ItemProps = DistributorPrice & {
  season: string;
  zone: string;
};

export function Item(props: ItemProps): React.ReactElement {
  const { season, zone } = props;

  const { inputsComponent, infoPrimary, infoSecondary, infoTertiary, image } = useItem(
    props,
    season,
    zone
  );

  return (
    <S.Container>
      <S.ImageContainer>
        <Image source={image} alt={infoSecondary} />
      </S.ImageContainer>

      <S.Wrapper>
        <S.Info>
          <S.InfoText
            scale="s"
            fontFamily="LFT Zeno"
            fontWeight="extraLight"
            textTransform="uppercase"
            isWrapped
          >
            {infoPrimary}
          </S.InfoText>

          <S.InfoText
            scale="s"
            fontFamily="LFT Zeno"
            fontWeight="extraLight"
            textTransform="uppercase"
            isWrapped
          >
            {infoSecondary}
          </S.InfoText>

          <S.InfoText
            scale="s"
            fontFamily="LFT Zeno"
            fontWeight="extraLight"
            textTransform="uppercase"
            isWrapped
          >
            {infoTertiary}
          </S.InfoText>
        </S.Info>

        <S.Inputs>{inputsComponent}</S.Inputs>
      </S.Wrapper>
    </S.Container>
  );
}
